import { render, staticRenderFns } from "./RaProductCard.vue?vue&type=template&id=6063d122&scoped=true"
import script from "./RaProductCard.vue?vue&type=script&lang=js"
export * from "./RaProductCard.vue?vue&type=script&lang=js"
import style0 from "./RaProductCard.vue?vue&type=style&index=0&id=6063d122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063d122",
  null
  
)

export default component.exports